module.exports = __webpack_public_path__ + "static/media/step_Image_First.a651a2ec.svg";